/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerieIdQueryResponse,
  GetApiV1SerieIdPathParams,
  GetApiV1SerieId401,
  GetApiV1SerieId404,
  GetApiV1SerieId500,
} from "../../types/serieRegistroController/GetApiV1SerieId.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SerieId } from "../../clients/serieRegistroController/getApiV1SerieId.ts";

export const getApiV1SerieIdQueryKey = (id: GetApiV1SerieIdPathParams["id"]) =>
  [{ url: "/api/v1/serie/:id", params: { id: id } }] as const;

export type GetApiV1SerieIdQueryKey = ReturnType<
  typeof getApiV1SerieIdQueryKey
>;

export function getApiV1SerieIdQueryOptions(
  id: GetApiV1SerieIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerieIdQueryKey(id);
  return queryOptions<
    GetApiV1SerieIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1SerieId401 | GetApiV1SerieId404 | GetApiV1SerieId500
    >,
    GetApiV1SerieIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SerieId(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados de uma série (título/resumo no idioma corrente) e as turmas vinculadas. **(Requer Authorization para autenticação)**
 * @summary Obter série por ID (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:id}
 */
export function useGetApiV1SerieId<
  TData = GetApiV1SerieIdQueryResponse,
  TQueryData = GetApiV1SerieIdQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SerieIdQueryKey,
>(
  id: GetApiV1SerieIdPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerieIdQueryResponse,
        ResponseErrorConfig<
          GetApiV1SerieId401 | GetApiV1SerieId404 | GetApiV1SerieId500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1SerieIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1SerieIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1SerieId401 | GetApiV1SerieId404 | GetApiV1SerieId500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
